import type {ReactElement} from 'react';
import React from 'react';
import {BaseFontSizeOption} from '@Components/poster-editor/components/poster-editing-side-panel/components/base-font-size-option';
import {useGetSelectedTranscriptItem} from '@Hooks/poster-editor/useGetSelectedTranscriptItem';
import {useGetKeyFromSubtitleTextStylesForTranscriptItem} from '@Hooks/poster-editor/useGetKeyFromSubtitleTextStylesForTranscriptItem';
import {useGetKeyFromTranscriptItem} from '@Hooks/poster-editor/useGetKeyFromTranscriptItem';

export function TranscriptFontSizeOption(): ReactElement<any> {
  const activeItem = useGetSelectedTranscriptItem();
  if (activeItem === null) {
    throw new Error('Transcript Item is undefined in TranscriptFontSizeOption');
  }

  const fontSize = useGetKeyFromSubtitleTextStylesForTranscriptItem('fontSize', false);
  if (fontSize === undefined) {
    throw new Error(`Transcript Item doesn't have font size attribute in sentenceTextStyles`);
  }

  const scaleX = useGetKeyFromTranscriptItem('scaleX');
  if (scaleX === undefined) {
    throw new Error(`Transcript Item doesn't have scaleX attribute`);
  }

  const updateFontSize = async (fontSize: number, undoable = true): Promise<void> => {
    await activeItem.updateAllSubtitlesStylesFromSubtitleObject(
      {
        sentenceTextStyles: {fontSize},
        activeWordTextStyles: {fontSize},
      },
      {undoable}
    );
  };

  return <BaseFontSizeOption fontSize={fontSize} scale={scaleX} onUpdateFontSize={updateFontSize} />;
}
